import { preloadImages, preloadFonts } from './utils';
// import Cursor from './cursor';
import { CursorHover } from './CursorHover';
import LocomotiveScroll from 'locomotive-scroll';
const imagesLoaded = require('imagesloaded');
import MenuController from './menuController';
import Masonry from 'masonry-layout'
import anime from 'animejs'
import Cursor from './cursor-n';
import ButtonCtrl from './buttonCtrl';

// Initialize the MenuController
new MenuController(document.querySelector('.menu'));
const cursor = new Cursor(document.querySelector('.cursor-n'));
const button = new ButtonCtrl(document.querySelector('.button-f'));

button.on('enter', () => cursor.enter());
button.on('leave', () => cursor.leave());

let education = document.getElementById("sec-1");
let logo = document.getElementById("logo");
let theEnd = document.getElementById("theEnd");


document.getElementById('enterPage').addEventListener('click', () => {
    setIsFirst();
})
document.getElementById('name-header').addEventListener('click', () => {
    lscroll.scrollTo(education)
})

function setIsFirst() {
    localStorage.setItem("firstReload", "done")
    window.location.reload();
}
anime.timeline({ loop: true })
    .add({
        targets: '.up-arrow',
        translateY: [5, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1400,
        delay: (el, i) => 300 + 30 * i
    }).add({
        targets: '.up-arrow',
        translateY: [0, -40],
        opacity: [1, 0],
        easing: "easeInExpo",
        duration: 1200,
        delay: (el, i) => 100 + 30 * i
    });
anime.timeline({ loop: true })
    .add({
        targets: '.click-enter',
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 1400,
        delay: (el, i) => 300 + 30 * i
    }).add({
        targets: '.click-enter',
        opacity: [1, 0],
        easing: "easeInExpo",
        duration: 1100,
        delay: (el, i) => 100 + 30 * i
    });
// Initialize Locomotive Scroll (horizontal direction)data-scroll-container-2
const lscroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    direction: 'horizontal',
    tablet: {
        smooth: true,
        direction: 'horizontal',
        horizontalGesture: true,
        horizontalOrder: true
    },
    smartphone: {
        smooth: true,
        direction: 'horizontal',
        horizontalGesture: true,
        horizontalOrder: true
    }
});

document.getElementById("myBar").style.width = 0 + "%";
let hideImages = document.getElementById("min-high");
if (document.body.clientHeight <= 765) {
    hideImages.classList.add("display-none");
}


const emojis = ["🔥", "👽", "😍", "🔥", "👆"];
const contacts = ["🤙", "👀", "📮", "💌", "👆"];


// Mouse effects on all links and others
[...document.querySelectorAll('a')].forEach(link => {
    link.addEventListener('mouseenter', () => cursor.enter());
    link.addEventListener('mouseleave', () => cursor.leave());
});

document.getElementById("ux-desc").textContent = "It aims to give a complete interaction interface to make the conference sessions feel easier to the attendees by having a keen overview of the conference and spending their time valuably by looking for any right session at the right time at the right place.";
// Preload images and fonts
Promise.all([preloadImages('.splash-content'), preloadImages('.art-work')]).then(() => {
    // Remove loader (loading class)
    document.body.classList.remove('loading');
});


//drag element

dragElement(document.getElementById("drag"));

function dragElement(elmnt) {
    var pos1 = 0,
        pos2 = 0,
        pos3 = 0,
        pos4 = 0;
    if (document.getElementById(elmnt.id + "-area")) {
        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + "-area").onmousedown = dragMouseDown;
    } else {
        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }
}


//loader

let enter1 = document.getElementById("enter-1");
let enter2 = document.getElementById("enter-2");
let enter3 = document.getElementById("enter-3");
let name = document.getElementById("name-header");
let preLoader = document.getElementById("start-name");

let terminal = document.getElementById("terminal");
let contact = document.getElementById("contact");
let social = document.getElementById('social');
let progressHide = document.getElementById('progressHide');
contact.classList.add("display-none");
enter1.classList.add("display-none");
enter2.classList.add("display-none");
enter3.classList.add("display-none");
name.classList.add("display-none");
social.classList.add("display-none");
progressHide.classList.add("display-none");
var currentdate = new Date();
var timeleft = 1;
var clickedEnter = false;
preLoader.textContent = '';
preLoader.textContent = "BHARATH BANDARU"
startAnime();
let er = document.getElementById("res")
let mainbody = document.getElementById("main-body")
let errorMessage = document.getElementById("error-message")
var nameTimer = setInterval(function () {
    timeleft--;
    // document.getElementById("countdowntimer").textContent = timeleft;
    if (timeleft <= 0) {
        preLoader.classList.add("display-none")

        if (window.innerWidth <= 1024 || window.innerHeight < 720) {
            errorMessage.innerText = "uh huh! this app is developed for a bigger screen."
            er.classList.remove("vis-hide")
            mainbody.classList.add("display-none")
            return
        }
        if ((window.innerHeight < 720 || window.innerWidth < 1280)) {
            if (localStorage.getItem("firstReload")) {
                er.classList.add("display-none")
                mainbody.classList.remove("display-none")
            } else {
                errorMessage.innerText = "uh huh! this app is developed for a bigger screen."
                er.classList.remove("vis-hide")
                mainbody.classList.add("display-none")
            }
        } else if (window.innerHeight > window.innerWidth && localStorage.getItem("firstReload")) {
            if (localStorage.getItem("firstReload")) {
                er.classList.add("display-none")
                mainbody.classList.remove("display-none")
            } else {
                errorMessage.innerText = "uh huh! rotate your device. For better experience open on a bigger screen."
                er.classList.remove("vis-hide")
                mainbody.classList.add("display-none")
            }

        } else {
            er.classList.add("display-none")
            mainbody.classList.remove("display-none")
        }
        enterLoader();
        clearInterval(nameTimer);
    }
}, 4000);

function startAnime() {
    anime.timeline({ loop: false })
        .add({
            targets: '.start-name',
            translateY: [10, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 600,
            delay: (el, i) => 300 + 30 * i
        }).add({
            targets: '.start-name',
            translateY: [0, -10],
            opacity: [1, 0],
            easing: "easeInExpo",
            duration: 600,
            delay: (el, i) => 100 + 30 * i,
            complete: function () {
                preLoader.textContent = "CROSSING OCEANS TO FETCH DATA .."
                anime.timeline({ loop: false })
                    .add({
                        targets: '.start-name',
                        translateY: [10, 0],
                        translateZ: 0,
                        opacity: [0, 1],
                        easing: "easeOutExpo",
                        duration: 1000,
                        delay: (el, i) => 300 + 30 * i
                    });
            }
        });
}

function enterLoader() {
    var skipTimer = setInterval(function () {
        timeleft--;
        // document.getElementById("countdowntimer").textContent = timeleft;
        if (timeleft <= 0) {
            if (!clickedEnter)
                enterPage();
            document.getElementById("countdown").innerHTML = ''
            clearInterval(skipTimer);
        }
    }, 1000);
}
var datetime = currentdate.toLocaleString('default', { weekday: 'long' }).substring(0, 3) +
    " " + currentdate.toLocaleString('default', { month: 'long' }) + " " + currentdate.getDate() + " " +
    currentdate.getHours() + ":" +
    currentdate.getMinutes() + ":" + currentdate.getSeconds();
document.getElementById("curr-date").innerHTML = datetime;
window.addEventListener('keydown', function (event) {
    if (event.key == 'Enter') {
        clickedEnter = true;
        document.getElementById("countdown").classList.add('vis-hide');
        enterPage();
        setIsFirst()
    }
});

let isLoaded = false

function enterPage() {
    document.getElementById('cur-blink').classList.add("display-none");
    document.getElementById('click-enter').classList.add("vis-hide");
    enter1.classList.remove("display-none");
    move();
    var t = setTimeout(() => {
        lscroll.scrollTo(education);
        enter2.classList.remove("display-none");
        enter3.classList.remove("display-none");
        name.classList.remove("display-none");
        contact.classList.remove("display-none");
        progressHide.classList.remove("display-none");
        social.classList.remove("display-none");
        anime.timeline({ loop: false })
            .add({
                targets: '.name-title',
                translateY: [30, 0],
                translateZ: 0,
                opacity: [0, 1],
                easing: "easeOutExpo",
                duration: 1000
            });
        anime.timeline({ loop: false }).add({
            targets: '.position-b-r',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 1500
        });
        anime.timeline({ loop: false }).add({
            targets: '.social',
            translateY: [50, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 2000
        })
        anime.timeline({ loop: false }).add({
            targets: '.git-social',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 300
        }).add({
            targets: '.drib-social',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 200
        }).add({
            targets: '.link-social',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 100
        }).add({
            targets: '.pin-social',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 50
        }).add({
            targets: '.twi-social',
            translateY: [30, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 20
        });
        clearTimeout(t);
        isLoaded = true;
        lscroll.update();
    }, 4200);
}

function move() {
    var elem = document.getElementById("loadingBar");
    var width = 0;
    var id = setInterval(frame, 50);
    var greenStr = '';

    function frame() {
        if (width >= 75) {
            clearInterval(id);
            terminal.classList.add("display-none")
        } else {
            width++;
            elem.style.width = width + '%';
            var num = width * 100 / 75;
            num = num.toFixed(0)
            document.getElementById("demo-bar-green").innerHTML = greenStr;
            if (width > 20) {
                enter2.classList.remove("display-none");
                enter3.classList.remove("display-none");
                document.getElementById("demo").innerHTML = num;
            }
            greenStr = greenStr + '|';
        }
    }
}


var experience = document.getElementById("experience");
let courses = document.getElementById("courses");
let portfolio = document.getElementById("portfolio");
let hiThere = document.getElementById("education");
let line = document.getElementById("line");
let lineHeight = document.querySelector('.ps-top-3');
let imagesSec = document.getElementById('images-sec');
let imageScroll = document.getElementById('image-scroll');
let imageScroll1 = document.getElementById('image-scroll-1');
let imageScroll2 = document.getElementById('image-scroll-2');
let prgs = document.getElementById('prgs');
let myProgress = document.getElementById('myProgress');
let logoimg = document.getElementById("logoimg");

var set = new Set();
lscroll.on('scroll', (args) => {

    if (typeof args.currentElements['section-0'] === 'object' || typeof args.currentElements['section-1'] === 'object' || typeof args.currentElements['portfolio'] === 'object') {
        customFadeInAnimation(portfolio, prgs, window.innerWidth - 300);
    } else {
        prgs.style.opacity = 0;
    }
    scrollProgress(args);

    // customFadeOutAnimation(lilbme, window.innerWidth - 300);
    customFadeOutAnimation(education, window.innerWidth - 300);
    customFadeOutAnimation(portfolio, window.innerWidth - 300);
    customFadeOutAnimation(hiThere, window.innerWidth - 300);
    customFadeOutAnimation(imagesSec, window.innerWidth - 300);
    // customFadeOutAnimation(hiThere, window.innerWidth - 300);
    // customFadeOutAnimation(portfolio, window.innerWidth - 300);
    // customFadeOutAnimation(zoom, window.innerWidth - 300);
    customFadeInAnimationDisplayNone(education, logoimg, window.innerWidth - 300);
    customFadeOutAnimation(imagesSec, window.innerWidth - 300);
    customFadeInAnimationDisplayNone(imagesSec, social, window.innerWidth - 300);
    customFadeInAnimation(imagesSec, myProgress, window.innerWidth - 300);
    customFadeInAnimation(imagesSec, experience, window.innerWidth - 500);

});
var currentSec = 0;
var sectionLengths = new Map();
sectionLengths.set(2, 0);
var sum = 0;

let closeTop = document.getElementById("contact-top");
let closeBottom = document.getElementById("contact-bottom");
window.addEventListener("load", function () {
    document.getElementById("closeContact").addEventListener("click", test);
    document.getElementById("contact").addEventListener("click", toggle);
    closeTop.addEventListener("click", test);
});
let isClicked = false;

function test() {
    isClicked = false;
    anime.timeline({ loop: false })
        .add({
            targets: '.contact-bottom',
            translateY: [0, 20],
            opacity: [1, 0],
            easing: "easeOutExpo",
            duration: 1200,
            delay: (el, i) => 100 + 30 * i
        });
    anime.timeline({ loop: false }).add({
        targets: '.contact-top',
        translateY: [0, 20],
        opacity: [1, 0],
        easing: "easeOutExpo",
        duration: 1200,
        delay: (el, i) => 100 + 30 * i
    });
    setTimeout(() => {
        closeBottom.classList.add("display-none");
        closeTop.classList.add("display-none");

    }, 500);
}

function toggle() {
    if (isClicked) {
        isClicked = false;
        test();
    } else {
        isClicked = true;
        test1();
    }
}

function test1() {
    isClicked = true;
    closeBottom.classList.remove("display-none")
    closeTop.classList.remove("display-none")
    anime.timeline({ loop: false })
        .add({
            targets: '.contact-bottom',
            translateY: [15, 0],
            translateZ: 0,
            opacity: [0, 1],
            easing: "easeOutExpo",
            duration: 500,
            delay: (el, i) => 100 + 30 * i
        });
    anime.timeline({ loop: false }).add({
        targets: '.contact-top',
        translateY: [15, 0],
        translateZ: 0,
        opacity: [0, 1],
        easing: "easeOutExpo",
        duration: 500,
        delay: (el, i) => 100 + 30 * i
    });
}

function scrollProgress(args) {

    for (let index = 0; index < 8; index++) {
        if (typeof args.currentElements['section-' + index] === 'object') {
            if (!set.has(index)) {
                sectionLengths.set(index, args.currentElements['section-' + index].el.clientWidth);
                sum = sum + args.currentElements['section-' + index].el.clientWidth;
                console.log('section-' + index + "w=" + args.currentElements['section-' + index].el.clientWidth + " sum=" + sum, "doc scrollwid=" + document.body.scrollWidth);
            }
            set.add(index);
        }
        if (typeof args.currentElements['section-5'] === 'object') {
            imagesSec.style.width = args.currentElements['section-5'].el.clientWidth + "px";
            imageScroll.style.width = args.currentElements['section-5'].el.clientWidth + "px";
        }
    }
    let currLength = 0;
    for (let index = 0; index < 8; index++) {
        if (typeof args.currentElements['section-' + index] === 'object') {
            currentSec = index;
            currLength += sectionLengths.get(index) * args.currentElements['section-' + index].progress;
            break;
        }
        currLength += sectionLengths.get(index);
    }
    var maxWidth = args.limit.x - document.body.clientWidth;
    var scrolled = (currLength / maxWidth) * 100;
    document.getElementById("myBar").style.width = scrolled + "%";
}

function winScrollWidth() {

    return 2000;
}

function customFadeOutAnimation(ele1, res) {
    if (ele1.getBoundingClientRect().x <= 0) {
        ele1.style.opacity = 1;
    } else {
        let op = (ele1.getBoundingClientRect().x - res) / res;
        if (op < 0 && Math.abs(op) >= 0 && Math.abs(op) <= 1)
            ele1.style.opacity = Math.abs(op);
        else
            ele1.style.opacity = 0;
    }
}

function customFadeInAnimation(ele2, ele3, res) {
    if (ele2.getBoundingClientRect().x <= 0) {
        ele3.style.opacity = 0;
    } else {
        let op = (ele2.getBoundingClientRect().x - res) / res;
        if (op < 0 && Math.abs(op) >= 0 && Math.abs(op) <= 1)
            ele3.style.opacity = 1 + op;
        else
            ele3.style.opacity = 1;
    }
}

function customFadeInAnimationboth(ele2, ele3, res) {
    if (ele2.getBoundingClientRect().x <= 0) {
        ele3.style.opacity = 0;
        ele2.style.opacity = 1;
    } else {
        let op = (ele2.getBoundingClientRect().x - res) / res;
        if (op < 0 && Math.abs(op) >= 0 && Math.abs(op) <= 1) {
            ele3.style.opacity = 1 + op;
            ele2.style.opacity = -(1 + op);
        } else {
            ele3.style.opacity = 1;
            ele2.style.opacity = 0;
        }
    }
}

function customFadeInAnimationDisplayNone(ele2, ele3, res) {
    if (ele2.getBoundingClientRect().x <= 0) {
        ele3.style.opacity = 0;
        ele3.classList.add("display-none")
    } else {
        ele3.classList.remove("display-none")
        let op = (ele2.getBoundingClientRect().x - res) / res;
        if (op < 0 && Math.abs(op) >= 0 && Math.abs(op) <= 1)
            ele3.style.opacity = 1 + op;
        else
            ele3.style.opacity = 1;
    }
}

